"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Input / Select Tooltip Info Box inside a tlField directive
 */
ngModule.directive("tlFieldTooltip", function () {
  return {
    restrict: "E",
    scope: true,
    transclude: true,
    require: ["tlFieldTooltip", "^tlField"],
    replace: true,
    template: '<div class="tl-field-tooltip"></div>',
    controller: function controller($scope, $element) {
      var ctrl = this,
        fieldCtrl = null,
        transcludeFn = null,
        tooltipContent = null,
        tooltipScope = null;
      ctrl.setTranscludeFn = function (_transcludeFn) {
        transcludeFn = _transcludeFn;
      };
      ctrl.setFieldCtrl = function (_fieldCtrl) {
        fieldCtrl = _fieldCtrl;
      };
      ctrl.unbindTooltip = function () {
        var inputs = fieldCtrl.getInputElements();
        inputs.qtip("destroy", true);
        if (tooltipScope) {
          tooltipScope.$destroy();
          tooltipScope = null;
          tooltipContent.remove();
          tooltipContent = null;
        }
      };
      ctrl.bindTooltip = function () {
        ctrl.unbindTooltip();
        tooltipScope = $scope.$new();
        tooltipContent = $("<div>");
        transcludeFn(tooltipScope, function (clone) {
          clone.appendTo(tooltipContent);
        });
        var inputs = fieldCtrl.getInputElements().first();
        _.defer(function () {
          // the defer is required to attach to re-compiled directives (tl-input-wrapper)
          var tooltipPosition = {
            container: $element.closest(".main-container"),
            my: 'middle left',
            at: 'middle right',
            adjust: {
              x: 3
            },
            viewport: $(window)
          };
          if ($scope.tlTooltipPosition === 'bottom') {
            tooltipPosition = {
              container: $element.closest(".main-container"),
              my: 'top center',
              at: 'bottom center',
              adjust: {
                y: 8
              },
              viewport: $(window)
            };
          }
          inputs.qtip({
            content: {
              text: tooltipContent
            },
            show: {
              delay: 450
            },
            position: tooltipPosition,
            style: {
              classes: 'qtip-info'
            }
          });
        });
      };
    },
    link: function link($scope, $el, $attrs, controllers, transcludeFn) {
      $el.hide();
      if ($attrs.tlTooltipPosition) {
        $scope.tlTooltipPosition = $attrs.tlTooltipPosition;
      }
      var ctrl = controllers[0];
      var fieldCtrl = controllers[1];
      ctrl.setTranscludeFn(transcludeFn);
      ctrl.setFieldCtrl(fieldCtrl);
      fieldCtrl.setTooltipCtrl(ctrl);
      $scope.$on("$destroy", function () {
        ctrl.unbindTooltip();
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/tlFieldTooltip.js
// module id = 2952
// module chunks = 13